import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const HomeRedirect = () => {
 const { isAuthenticated, loading } = useAuth();

 if (loading) {
    return <div></div>; // Quick operation without connection, do not show anything
 }

 return <Navigate to={isAuthenticated ? "/home" : "/login"} replace />;
};

export default HomeRedirect;
